import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { decodeHtmlEntities } from '../../../containers/utils';


const currencySymbols = {
  USD: '$',
  GBP: '£',
};

const AcceptedLeadCard = (props) => {
  const click = () => props.onClick(props.lead.id);

  // Hide lead button and modal
  const [isHidden, setIsHidden] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [isAnimating, setIsAnimating] = React.useState(false);
  const hideButtonRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const isLeadHidden = localStorage.getItem(`hidden_lead_${props.lead.id}`);
    setIsHidden(isLeadHidden === 'true');
  }, [props.lead.id]);

  const handleHideClick = () => {
    setShowModal(true);
  };

  const handleHideLead = () => {
    setIsAnimating(true);
    setTimeout(() => {
    setIsHidden(true);
    setShowModal(false);
    setIsAnimating(false);
    localStorage.setItem(`hidden_lead_${props.lead.id}`, 'true');
    }, 500);
  };

  const handleCancelHide = () => {
    setShowModal(false);
  };

  const handleLeadClick = () => {
    props.onClick(props.lead.id);
  };

  // @TODO: For Felipe - should this be removed in this task?
  const handleMatchScoreClick = () => {
    props.onClick(props.lead.id);
  };

  if (isHidden) {
    return null;
  }

  const calculateModalYPosition = () => {
    if (hideButtonRef.current) {
      const hideButtonRect = hideButtonRef.current.getBoundingClientRect();
      const hideButtonTop = hideButtonRect.top + window.scrollY;
      const modalYPosition = hideButtonTop - 30;
      return modalYPosition;
    } else {
      console.error('Error: hideButtonRef is not available.');
      return null;
    }
  };

  const modalYPosition = calculateModalYPosition();

  let email = props.lead.contact_email;
  if (email && email.length > 25) {
    email = `${email.substring(0, 22)}...`;
  }


  // Determine display field based on market
  let displayFields;

  if (props.lead.market_name === 'EHR') {
    displayFields = {
      firstField: {
        name: 'Practitioners',
        value: decodeHtmlEntities(props.lead.practicesizenonrange) || 'N/A',
      },
      secondField: {
        name: 'Specialty',
        value: decodeHtmlEntities(props.lead.practicespecialty) || 'N/A',
      }
    };
  } else if (props.lead.market_name === 'HRMS') {
    displayFields = {
      firstField: {
        name: 'Revenue',
        value: decodeHtmlEntities(props.lead.revenue_formatted) || 'N/A',
        aria_label: props.lead.revenue_formatted
            ? decodeHtmlEntities(props.lead.revenue_formatted)
            .replace('$', '')
            .replace('£', '')
            .replace('bn', ' billion')
            .replace('m', ' million') + ' dollars'
            : '',
      },
      secondField: {
        name: 'Industry',
        value: decodeHtmlEntities(props.lead.sagecampaignindustries) || 'N/A',
      }
    };
  } else {
    displayFields = {
      firstField: {
        name: 'Revenue',
        value: decodeHtmlEntities(props.lead.revenue_formatted) || 'N/A',
        aria_label: props.lead.revenue_formatted
            ? decodeHtmlEntities(props.lead.revenue_formatted)
            .replace('$', '')
            .replace('£', '')
            .replace('bn', ' billion')
            .replace('m', ' million') + ' dollars'
            : '',
      },
      secondField: {
        name: 'Industry',
        value: decodeHtmlEntities(props.lead.industry_sector) || 'N/A',
      }
    };
  }

  function renderPriorityPill(lead) {
    // the underscore disables this for now
    if (window.priorityPricingEnabled_ !== true) {
        return null;
    }

    let style = {
        width: 40,
        height: 40,
        fontSize: 15,
        fontWeight: 700,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '100%',
        marginLeft: '2rem',
        marginRight: '-2.5rem',
        userSelect: 'none',
    };
    let content = '';

    if (lead.distribution_position > 0 && lead.distribution_position < window.maximumPriorityPosition) {
        style.backgroundColor = '#ffe338';
        content = lead.distribution_position.toString();
    } else {
        style.backgroundColor = '#e0e0e0';
        content = 'S';
    }

    return <div style={style}>{content}</div>;
  }

  return (
    <>
      {!isHidden && (
          <div className={`data-list-tr ${isAnimating ? 'slide-up' : ''}`}>
            <div className="data-list-td data-list-main-col" onClick={handleLeadClick}>
              <div className="data-list-tab">
                <div className={`tab ${props.lead.qualification_type === 'phone_qualified' ? 'tab-tq' : 'tab-mql'}`}>
                  <span>
                    {props.lead.qualification_type === 'phone_qualified' ? 'TQ' : 'MQL+'}
                  </span>
                </div>
              </div>
              <div style={{ height: '100%', display: 'flex', flexDirection: 'col', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    { renderPriorityPill(props.lead) }
                    <em className="t-bold">{decodeHtmlEntities(props.lead.company_name)}</em>
                </div>
              </div>
            </div>
            <div className="data-list-td data-list-td--center data-list-5-col data-first-row">
              <div className="data-list-td-header">{displayFields.firstField.name}</div>
              {displayFields.firstField.value}
            </div>
            <div className="data-list-td data-list-td--center data-list-5-col align-row">
              <div className="data-list-td-header">{displayFields.secondField.name}</div>
              {displayFields.secondField.value}
            </div>
            <div className="data-list-td data-list-td--center data-list-5-col align-row">
              <div className="data-list-td-header">Core Problem</div>
              {decodeHtmlEntities(props.lead.problem) || 'N/A'}
            </div>
            <div className="data-list-td data-list-td--center data-list-5-col align-row">
              <div className="data-list-td-header">Received</div>
              {
                props.lead.combined_date ?
                    moment(props.lead.combined_date).format('MM/DD') :
                    ''
              }
            </div>
            <div className="data-list-td data-list-td--center data-list-5-col align-row">
              <div className="data-list-td-header">Price</div>
              <span className="flair--price-purchased">
                BOUGHT
                 </span>
            </div>

            <div className="data-list-td data-list-td--center" style={{display: 'flex', alignItems: 'center'}}>
            <span className="red-circle-with-x" onClick={handleHideClick} ref={hideButtonRef}>
              X
            </span>
            </div>
          </div>
      )}

      {showModal && (
          <div className="modal" style={{position: 'absolute', right: 140, top: modalYPosition}}>
            <div className="modal-content">
            <p>Do you want to hide this lead?</p>
              <div>
                <button className="yes" onClick={handleHideLead}>YES</button>
                <button className="no" onClick={handleCancelHide}>NO</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

AcceptedLeadCard.propTypes = {
lead: PropTypes.object.isRequired,
onClick: PropTypes.func,
  currency: PropTypes.string.isRequired,
};
AcceptedLeadCard.defaultProps = {
onClick: () => {},
};

export default AcceptedLeadCard;
